var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 72 72",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow-right-a",
    d: "M26.9747794,6.96804002 L54.5548531,34.5856319 C55.0259154,35.0566942 55.2614465,35.6152991 55.2614465,36.2614465 C55.2614465,36.907594 55.0259154,37.4661988 54.5548531,37.9372612 L26.9747794,65.5548531 C26.5037171,66.0259154 25.9388592,66.2614465 25.2802057,66.2614465 C24.6215521,66.2614465 24.0566942,66.0259154 23.5856319,65.5548531 L17.4451469,59.3768499 C16.9740846,58.9057875 16.7385535,58.3471827 16.7385535,57.7010352 C16.7385535,57.0548878 16.9740846,56.4962829 17.4451469,56.0252206 L37.208921,36.2614465 L17.4451469,16.4976725 C16.9740846,16.0266102 16.7385535,15.4680053 16.7385535,14.8218578 C16.7385535,14.1757104 16.9740846,13.6171055 17.4451469,13.1460432 L23.5856319,6.96804002 C24.0566942,6.4969777 24.6215521,6.26144654 25.2802057,6.26144654 C25.9388592,6.26144654 26.5037171,6.4969777 26.9747794,6.96804002 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow-right-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right.d5edfb6372b716ba8b5aabb4d0d8afc6.svg";